var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-function area"
  }, [_vm._m(0), _vm._l(_vm.skillList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "product-function__skill"
    }, [_c("div", {
      staticClass: "title puHui-M"
    }, [_c("span", [_vm._v(_vm._s(item.type))])]), _c("Skill", {
      attrs: {
        skillList: item.category,
        lineClamp: 5,
        cardStyle: {
          height: "300px"
        }
      }
    })], 1);
  })], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-function__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("FUNCTION")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("功能介绍")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };